import { IngredientType } from '@libs/trip-planner-interfaces';

import { BaseIngredient } from './baseIngredient';
import type { ActivityIngredient } from './activityIngredient';

export class OwnStayIngredient extends BaseIngredient {
  public numberOfNights?: number;

  public subIngredients: ActivityIngredient[] = [];

  constructor() {
    super(IngredientType.OwnStay);
  }

  public isIngredientCorrect(): boolean {
    return true;
  }
}
